import React from 'react';

interface SeverityLevelProps {
    level: number;
    color: string;
    isSelected: boolean;
    onSelect: () => void;
}

const SeverityLevel: React.FC<SeverityLevelProps> = ({ level, color, isSelected, onSelect }) => (
    <p
        className={`rounded-full text-sm font-bold aspect-square px-1.5 min-w-6.25 flex items-center justify-center cursor-pointer box-border transition-colors duration-200 ease-out border-4 ${
          isSelected ? 'border-black' : 'border-transparent'
        }`}
        style={{ backgroundColor: color }}
        onClick={onSelect}
    >
        {level}
    </p>
);

export default SeverityLevel;
